import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
    public message = '';
    public show = false;
    constructor() { }
    close() {
        this.show = false;
    }
}
